import { render } from "./ChatUserList.vue?vue&type=template&id=93db0e40"
import script from "./ChatUserList.vue?vue&type=script&lang=js"
export * from "./ChatUserList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__